import React, { Component } from "react"
import styled from "styled-components"

const SectionBackground = styled.div`
  background-image: url(${props => props.background});
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  z-index: ${props => (props.isLower ? "-2" : "-1")};
  margin: 0 auto;
  width: ${props => props.backgroundWidth};
  height: ${props => props.backgroundHeight};
  top: ${props => props.backgroundTop};
  left: ${props => props.backgroundLeft};
  right: ${props => props.backgroundRight};
  max-width: 2000px;
  transform: scale(${props => props.backgroundScale});
  transform-origin: ${props => props.backgroundOrigin};
`

export default ({
  className,
  background,
  backgroundWidth,
  backgroundHeight,
  backgroundTop,
  backgroundPosition,
  backgroundRight,
  backgroundLeft,
  backgroundScale,
  backgroundOrigin,
  isLower,
}) => (
  <SectionBackground
    className={className}
    isLower={isLower}
    background={background}
    backgroundPosition={backgroundPosition}
    backgroundWidth={backgroundWidth}
    backgroundHeight={backgroundHeight}
    backgroundTop={backgroundTop}
    backgroundLeft={backgroundLeft}
    backgroundRight={backgroundRight}
    backgroundScale={backgroundScale}
    backgroundOrigin={backgroundOrigin}
  />
)



// WEBPACK FOOTER //
// ./src/components/SectionBackground.js